const EzugiSpribeCasino = (props) => {

  return (
    <>
      <div className={`all-casino ${props?.activeCasino === 'Spribe' ? 'active' : ''}`}>
      <div className="page-live-casino">
            <ul className="casinos">
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `keno`)}><img src="https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_keno.webp"  alt="SPRIBE CASINO"/></li>
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `mini-roulette`)}><img src="https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_roulette.webp"  alt="SPRIBE CASINO"/></li>
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `hi-lo`)}><img src="https://img.jaipurapps.com/all-casino-img/lucky-7//sbe_hilo.webp"  alt="SPRIBE CASINO"/></li>
            </ul>
            <ul className="casinos">
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `dice`)}><img src="https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_dice.webp"  alt="SPRIBE CASINO"/></li>
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `mines`)}><img src="https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_mines1.webp"  alt="SPRIBE CASINO"/></li>
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `plinko`)}><img src="https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_plinko.webp"  alt="SPRIBE CASINO"/></li>
            </ul>
            <ul className="casinos">
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `goal`)}><img src="https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_goal1.webp"  alt="SPRIBE CASINO"/></li>
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `hotline`)}><img src="https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_hotline.webp"  alt="SPRIBE CASINO"/></li>
                <li className="casino-links" onClick={() => props?.CreateAndLaunchWCOCasino(`SPB`, `aviator`)}><img src="https://img.jaipurapps.com/all-casino-img/avitor-crash/sbe_aviator1.webp"  alt="SPRIBE CASINO"/></li>
            </ul>
        </div>
      </div>
    </>
  );
};

export default EzugiSpribeCasino;
